import {Address} from "../../model/Address";
import './address-input.component.scss';

export class AddressInputController {
    public static instance = {
        template : require("./address-input.component.html"),
        controller: [ AddressInputController ],
        bindings: {
            address: '='
        }
    };

    private address: Address;

    public onEdited = () => {
        this.address.verification = {
            valid : false,
            message : 'Address form was edited and needs further verification'
        };
    };

}